import React from 'react';
import { BlockquoteIcon } from '@/components/tiptap-icons/blockquote-icon';
import {
  POST_EDITOR_COLOR_PICKER_TITLES,
  POST_EDITOR_QUOTE_SWATCHES,
  POST_EDITOR_TOOLBAR_TEXT_CLASS_BY_HEX,
} from '../lib/post_editor_constants.js';

/** Quote color grid — same markup/classes as the main toolbar color dropdown. */
export function QuoteColorPickerMenu({
  selectedVariant = 'black',
  onSelect,
  title = POST_EDITOR_COLOR_PICKER_TITLES.quoteColor,
  includeMenuChrome = false,
}) {
  const grid = (
    <div className="ps-quote-grid">
      {POST_EDITOR_QUOTE_SWATCHES.map(({ id, hex }) => {
        const selected = selectedVariant === id;
        const textClass = POST_EDITOR_TOOLBAR_TEXT_CLASS_BY_HEX[hex.toUpperCase()] || '';
        return (
          <button
            key={id}
            type="button"
            title={`${id} quote`}
            aria-label={`Quote color ${id}`}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onSelect?.(id)}
            className={['ps-quote-swatch', textClass, selected ? 'is-selected' : ''].filter(Boolean).join(' ')}
          >
            <BlockquoteIcon />
          </button>
        );
      })}
    </div>
  );

  if (!includeMenuChrome) return grid;

  return (
    <div className="ps-color-menu ps-color-menu--limited">
      <div className="ps-toolbar-menu__title">{title}</div>
      {grid}
    </div>
  );
}
